var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.care_vital_sign.care_has_vital_signs.length > 0)?_c('div',[_c('p',{class:[
      'm-0',
      parseInt(_vm.item.description) >= 70 &&
        parseInt(_vm.item.description) <= 110 &&
        'color-green',
      parseInt(_vm.item.description) >= 51 &&
        parseInt(_vm.item.description) <= 69 &&
        'color-orange',
      parseInt(_vm.item.description) >= 111 &&
        parseInt(_vm.item.description) <= 125 &&
        'color-orange',
      (parseInt(_vm.item.description) >= 126 ||
        parseInt(_vm.item.description) <= 51) &&
        'color-red' ]},[_vm._v(" "+_vm._s(_vm.item.description)+" "+_vm._s(_vm.item.abbreviation)+" ")]),_c('p',{staticClass:"mb-1 worksansr text-twelve upper-text"},[_vm._v(" CADASTRADO POR: "+_vm._s(_vm.item.user_name)+" ")]),_c('hr')]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }